import { render } from "./VehicleManufacturersView.vue?vue&type=template&id=6a8feb8c&ts=true"
import script from "./VehicleManufacturersView.vue?vue&type=script&lang=ts"
export * from "./VehicleManufacturersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__